
class Payment {
  constructor(params) {
    this.datePay = params.datePay;
    this.idTicket = params.idTicket;
    this.amount = params.amount;
    this.paymentTicket = params.paymentTicket;
  }
}

export { Payment };



// WEBPACK FOOTER //
// ./src/models/Payment.js